module.exports = __webpack_public_path__ + "img/lg_ring_r_i_null_1@2x.0177fb1e.png";